import { unwrapRepeater } from "../../utils/CockpitUtils";
import PeopleItem from "./item";
import "./style.scss";

const PeopleGrid = ({ people = [], heading = "" }) => {
  people = unwrapRepeater(people);

  return (
    <>
      {Array.isArray(people) && (
        <div className="cockpit-people_grid">
          {heading && <h2 className="contacts-heading">{heading}</h2>}
          <div className="people-grid" role="list">
            {people.map(
              person =>
                person && (
                  <PeopleItem
                    id={person._id}
                    name={person.display}
                    key={person._id}
                  />
                )
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default PeopleGrid;
